import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import AuthContext from "../../context/authentication/authContext";
import PortalContext from "../../context/portal/portalContext";
import useMediaQuery from "../../hooks/useMediaQuery";

import ContainerWidgets from "./ContainerWidgets";
import ChartBart from "../core/ChartBart";
import Loading from "../core/Loading";

import "react-tabs/style/react-tabs.css";
import "./Stadistics.css";

const useStyles = makeStyles({
  root: {
    width: "100%",
    height: "100%",
    flexGrow: 1,
  },
  componentTitle: {
    fontSize: 18,
    float: "left",
  },
  spanNoData: {
    marginTop: "50%",
  },
});

/* const data = []; */

const Stadistics = (props) => {
  const portalContext = useContext(PortalContext);
  const  {data,isBill} = portalContext
  //redirigir a page de error
  const classes = useStyles();
  const isMobile = useMediaQuery("max-width", 800);
  if (!data) {
    return <Loading />;
  }

  ////console.log(isBill)
  const documentType = isBill==="ISBILL" ? 'Factura':'Boleta'
  const {
    netTotalInvoiced,
    vatAmount,
    remainingDaysForVATDeclaration,
    totalInvoiced,
  } = data;

  const dataWidgets = [
    {
      value: Number(remainingDaysForVATDeclaration).toLocaleString(),
      descripcion: "Días faltantes para la declaración de IVA",
      currency: "",
      icon: "calendar",
    },
    {
      value: Number(netTotalInvoiced).toLocaleString("es-CL"),
      descripcion: "Ventas neta",
      currency: "$",
      icon: "money",
    },
    {
      value: Number(vatAmount).toLocaleString("es-CL"),
      descripcion: "Monto IVA",
      currency: "$",
      icon: "error",
    },
    {
      value: Number(data.quantityTicket).toLocaleString(),
      descripcion: `Cantidad de ${documentType}s`,
      currency: "",
      icon: "file",
    },
    {
      value: Number(totalInvoiced).toLocaleString("es-CL"),
      descripcion: "Ventas total",
      currency: "$",
      icon: "money",
    },
  ];

  return (
    <>
      <div className={classes.root}>
        <Typography className={classes.componentTitle} color="textSecondary">
          Estadísticas {`${documentType}s`}
        </Typography>
        {!isMobile ? (
          <DesktopStadistics data={data} dataWidgets={dataWidgets} isBill={props.isBill}/>
        ) : (
          <ResponsiveStadistics data={data} dataWidgets={dataWidgets}  isBill={props.isBill}/>
        )}
      </div>
    </>
  );
};

const DesktopStadistics = (props) => {
  const { data, dataWidgets } = props;
  const classes = useStyles();
  const { invoicedMonths, billedMonths } = data;

  const documentType = props.isBill ? 'Factura':'Boleta'
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={5} style={{ display: "grid" }}>
        {invoicedMonths.length === 0 ? (
          <span className={classes.spanNoData}>No hay datos</span>
        ) : (
          <ChartBart
            title="Ventas"
            color="#12B1EE"
            dataChart={invoicedMonths}
          />
        )}
      </Grid>
      <Grid item xs={12} sm={5} style={{ display: "grid" }}>
        {billedMonths.length === 0 ? (
          <span className={classes.spanNoData}>No hay datos</span>
        ) : (
          <ChartBart title={`${documentType}s`} color="#6100ED" dataChart={billedMonths} />
        )}
      </Grid>
      <Grid item xs={12} sm={2} style={{ padding: "0px" }}>
        <ContainerWidgets data={dataWidgets} />
      </Grid>
    </Grid>
  );
};

const ResponsiveStadistics = (props) => {
  const { data, dataWidgets } = props;
  const { invoicedMonths, billedMonths } = data;
  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={2}>
        <ContainerWidgets data={dataWidgets} />
      </Grid>
      <Tabs style={{ width: "100%" }}>
        <TabList>
          <Tab>Ventas</Tab>
          <Tab>Boletas</Tab>
        </TabList>
        <TabPanel>
          <Grid item xs={12} sm={2}>
            {invoicedMonths.length === 0 ? (
              <span className={classes.spanNoData}>No hay datos</span>
            ) : (
              <ChartBart
                title="Ventas"
                color="#12B1EE"
                dataChart={invoicedMonths}
              />
            )}
          </Grid>
        </TabPanel>
        <TabPanel>
          <Grid item xs={12} sm={2}>
            {billedMonths.length === 0 ? (
              <span className={classes.spanNoData}>No hay datos</span>
            ) : (
              <ChartBart
                title="Boletas"
                color="#6100ED"
                dataChart={billedMonths}
              />
            )}
          </Grid>
        </TabPanel>
      </Tabs>
    </Grid>
  );
};

export default Stadistics;
